import React from 'react';
import { connect } from "react-redux";
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import updateNapUredaj from './../../../API/Admin/PutNaplatniUredaj'
import Dropdown from 'react-dropdown';
import businessPremisesList from './../../../API/Admin/GetBusinessPremisesList'
import Loader from './../../../Global/loader'

class UpdatePosProstor extends React.Component {
    constructor(props) {
        super(props); 
        this.submitUpdate = this.submitUpdate.bind(this);
    }

    state={
        listPosProstoOption: [],
        loadingPosProList: true,
        pickedPosProstor: {},
        loading: true,
        ecommerce: this.props.oneNapUred.ecommerce
    }

    componentDidMount = async () => {
        this.setState({
            loadingPosProList: true,
            loading: true
        })
        const lista = await businessPremisesList(this.props.oneClientInfo.uuid)
        if(lista.data.length > 0){
            this.props.mapState("ADMIN_MAP_POS_PRO_LIST", lista.data)
        }

        let propsOption =  []
        this.props.posProstorList.map((data) => (
            propsOption.push({label: data.premises_name, value: data.uuid})
        ))

        await this.setPosProstor({value:this.props.oneNapUred.businessPremisesUuid, label: this.props.oneNapUred.businessPremises})

        await this.setState({
            listPosProstoOption: propsOption,
            loadingPosProList: false,
            loading: false
        }) 
    }

    // dropdown poslovni prostor
    setPosProstor = async (data) => {
        this.props.posProstorList.filter(devices => devices.uuid === data.value).map(filteredData => (
            //this.props.mapState("CLIENT_MAP_PICKED_POS_PROSTOR", filteredData)
            
            this.setState({
                pickedPosProstor : filteredData
            })
        ))
    }
    
    handleUpdateChange = async (e) => {
        await this.props.mapState("ADMIN_CHANGE_ONE_NAPLATNI_UREDAJ_DETAILS", e.target) 
    }

    submitUpdate = async (e) =>{
        this.setState({ loading: true })
        e.preventDefault()
        const oneNapUred = { ...this.props.oneNapUred };
        oneNapUred.ecommerce = this.state.ecommerce
        let updatePP = await updateNapUredaj(this.props.oneClientInfo.uuid, oneNapUred, this.state.pickedPosProstor.uuid)
        if(updatePP.data.data.operationResult === "SUCCESS"){
            store.addNotification({
                title: "Uspješno!",
                message: "Promjena naplatnog uređaja je izvršena",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });

            this.setState({ loading: false })
        }
        else(
            store.addNotification({
                title: "Greška!",
                message: "Došlo je do pogreške prilikom promjene naplatnog uređaja, molimo pokušajte ponovno.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })
        )
        this.setState({ loading: false })
        this.props.goBack()
    }

    handleEcommerce = async () => {
        this.setState({
            ecommerce: !this.state.ecommerce
        })
    } 

    render(){  
        return (
            <>
                {this.state.loading ?
                    <div style={{position: "sticky", marginTop: "50px", left: "50%"}}>
                        <Loader />
                    </div>
                :
                <form style={{padding: "40px"}}>
                    <div className="row">          
                        <div className="col col-sm-12 col-lg-6 col-md-12">
                            <div className="form-group row">
                                <label htmlFor="label" className="col-sm-4 col-form-label">TID</label>
                                <div className="col-sm-8">
                                    <input      
                                            id="tid"                          
                                            type="text"
                                            value={this.props.oneNapUred.tid}
                                            onChange={e => this.handleUpdateChange(e)}
                                        />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="address" className="col-sm-4 col-form-label">Oznaka</label>
                                <div className="col-sm-8">
                                    <input
                                        id="label"  
                                        type="text"
                                        value={this.props.oneNapUred.label}
                                        onChange={e => this.handleUpdateChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="description" className="col-sm-4 col-form-label">Opis</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="description"                         
                                        type="text"
                                        value={this.props.oneNapUred.description}
                                        onChange={e => this.handleUpdateChange(e)}
                                    />
                                </div>
                            </div>  

                            <div className="form-group row">
                                <label htmlFor="premises_name" className="col-sm-4 col-form-label">ISU</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="isuNumber"                         
                                        type="text"
                                        value={this.props.oneNapUred.isuNumber}
                                        onChange={e => this.handleUpdateChange(e)}
                                    />
                                </div>
                            </div> 

                            <div className="form-group row">
                                <label htmlFor="listPosProstoOption" className="col-sm-4 col-form-label">Poslovni prostor</label>
                                <div className="col-sm-8">
                                    {this.state.loadingPosProList ? 
                                        <input 
                                            disabled
                                            type="text"
                                            value={null}
                                            placeholder="Učitavanje..."
                                        />
                                    :
                                        <Dropdown 
                                            isClearable={true}
                                            //placeholder={this.state.pickedPosProstor.label} 
                                            options={this.state.listPosProstoOption} 
                                            onChange={this.setPosProstor} 
                                            //value={this.state.nazNapUred} 
                                            value={this.state.pickedPosProstor.premises_name ? this.state.pickedPosProstor.premises_name: ""}
                                        />
                                    }
                                </div> 
                            </div> 
                            <div className="form-group row" style={{ alignItems: 'center' }}>
                                <label htmlFor="E-commerce" className="col-sm-4 col-form-label">E-commerce</label>
                                <div className="col-sm-8">
                                    <label className="form-check-label" htmlFor="ecommerce">
                                        <input      
                                            id="ecommerce"                                          
                                            type="checkbox"
                                            checked={this.state.ecommerce}
                                            onChange={e => this.handleEcommerce(e)}
                                        />
                                        &nbsp;&nbsp; e-commerce
                                    </label>
                                </div>
                            </div>
                            <div className="col-sm-4" style={{float:"right",padding: "0px"}}>
                                <button                                     
                                    className="btn btn-info" 
                                    style={{padding:"10px"}} 
                                    onClick={(e) => this.submitUpdate(e)}
                                >
                                    Spremi
                                </button>
                            </div>                                  
                        </div>                        
        
                        
                    </div>           
                    
                    <div 
                        className="btn btn-default" 
                        style={{/*width: "100%",*/ marginBottom: "10px", marginTop: "10px"}}
                        onClick={(e) => this.props.goBack(e)}
                    >
                        <BsBackspaceFill size={30} />  <strong>Nazad</strong>
                    
                    </div>    
                
                </form>
                }        
            </>

        )
    }
}
const mapStateToProps = state => {
    return {
        oneClientInfo: state.adminClient.oneClient,
        posProstorList: state.adminClient.posProstorList,
        oneNapUred: state.adminClient.oneNapUred
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(UpdatePosProstor);


